import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from 'react'

type CanvasInteractionsContextValue = {
  isEnabled: boolean
  setEnabled: (enabled: boolean) => void
}

const CanvasInteractionsContext = createContext<
  CanvasInteractionsContextValue | undefined
>(undefined)

type CanvasInteractionsProviderProps = {
  children: React.ReactNode
}

export function CanvasInteractionsProvider({
  children,
}: CanvasInteractionsProviderProps) {
  const [isEnabled, setEnabledState] = useState(true)

  const setEnabled = useCallback((enabled: boolean) => {
    setEnabledState(enabled)
  }, [])

  const value = useMemo(
    () => ({
      isEnabled,
      setEnabled,
    }),
    [isEnabled, setEnabled]
  )

  return (
    <CanvasInteractionsContext.Provider value={value}>
      {children}
    </CanvasInteractionsContext.Provider>
  )
}

export function useCanvasInteractions() {
  const context = useContext(CanvasInteractionsContext)
  if (!context) {
    throw new Error(
      'useCanvasInteractions must be used within a CanvasInteractionsProvider'
    )
  }
  return context
}
